import {
  ArrowUpRightIcon,
  ExclamationTriangleIcon,
  XCircleIcon,
  XMarkIcon,
} from "@heroicons/react/24/solid";
import { Button } from "components/Graphs/Button";
import React, { useContext, useEffect, useState } from "react";
import { api, BaseRes, AxiosRes } from "../../server/config";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { isKasAuthFlow } from "server/kas/utils";
import { useAuth0 } from "@auth0/auth0-react";
import Modal from "components/Modals/Modal";
import { UserContext } from "contexts/UserContext";
import { NewButton } from "components/Environment/List";
import { OrgContext } from "contexts/OrgContext";
import { useHistory } from "react-router-dom";

export const DeploymentBanner: React.FC = (props) => {
  const userContext = useContext(UserContext);
  const [showBanner, setShowBanner] = useState(true);
  const orgContext = useContext(OrgContext);
  const history = useHistory();
  useEffect(() => {
    const alreadyClosed = localStorage.getItem(
      `deployment-banner-closed-${userContext.me?.id || ""}`
    );
    if (alreadyClosed) {
      setShowBanner(false);
    }
  }, []);

  return (
    showBanner && (
      <div className="w-full max-w-7xl mx-auto sm:px-6 lg:px-8 py-2">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="flex flex-row items-center justify-start border border-highlight rounded-lg p-2">
            <div className="flex flex-row items-center w-full">
              <div className="flex flex-row justify-center w-full">
                <div className="flex flex-row items-center gap-1 text-sm justify-center text-primary">
                  Deployments are now in public beta! Launch your first NIM
                  today🤙
                </div>
                <Button
                  className="h-6 ml-2"
                  onClick={() => {
                    history.push(`/org/${orgContext.activeOrgId}/deployments`);
                  }}
                  disabled={false}
                >
                  <span className="text-xs">Try Now</span>
                  <ArrowUpRightIcon className="w-3 h-3" />
                </Button>
              </div>
              <div
                className="flex flex-row items-center gap-1 cursor-pointer"
                onClick={() => {
                  localStorage.setItem(
                    `deployment-banner-closed-${userContext.me?.id || ""}`,
                    "true"
                  );
                  setShowBanner(false);
                }}
              >
                <XCircleIcon className="w-6 h-6 text-red-500" />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default DeploymentBanner;
